const ACCESS_TOKEN_KEY = 'app_token';

export const tokenStorage = {
  getAccessToken: (): string | null => {
    return localStorage.getItem(ACCESS_TOKEN_KEY);
  },
    
  setAccessToken: (token: string): void => {
    localStorage.setItem(ACCESS_TOKEN_KEY, token);
  },
    
  clearTokens: (): void => {
    localStorage.removeItem(ACCESS_TOKEN_KEY);
  }
};

export const useToken = () => {
  return {
    setToken: (token: string) => {
      tokenStorage.setAccessToken(token);
    },
    clearToken: () => {
      tokenStorage.clearTokens();
    },
    token: tokenStorage.getAccessToken(),
  };
};